/**
 * La versión HORNEADA en el bundle por Vite (define, vite.config.js): describe exactamente el
 * código que este navegador está ejecutando. Es la referencia del aviso de «versión nueva» y
 * se enseña en el pie para poder diagnosticar a simple vista un bundle desfasado.
 */
// eslint-disable-next-line no-undef -- lo define Vite en build
export const VERSION_BUNDLE = typeof __VERSION_CONSOLA__ !== 'undefined' ? __VERSION_CONSOLA__ : null

export const firmaVersion = (v) => `${v.version}·${v.shortCommit ?? ''}`
